export default __webpack_public_path__ + "static/media/IC00002_1-disciple_icon_no_fill.6adb5703.svg";